import { createContext, useContext, type FC, type ReactNode } from 'react'
import { type ViewPageStore } from 'pages/surveys/pages/view/store/viewPageStore'

export const ViewPageContext = createContext<ViewPageStore | null>(null)

export const useViewPageContext = () => {
  const context = useContext(ViewPageContext)

  if (context === null)
    throw new Error('You have forgotten to wrap your root component with ViewPageContext')

  return context
}

type IProviderViewPageProps = {
  value: ViewPageStore
  children: ReactNode
}

export const ProviderViewPage: FC<IProviderViewPageProps> = ({ value, children }) => {
  return <ViewPageContext.Provider value={value}>{children}</ViewPageContext.Provider>
}
